import NotificationManager, { toast } from 'react-hot-toast';
// Toast
export const Toast = ({ type = 'success', message, duration = 3000 }) => {
  toast.dismiss();
  if (typeof window === 'undefined') return;

  if (Array.isArray(message)) {
    let item;

    // eslint-disable-next-line no-restricted-syntax
    for (item of message) {
      NotificationManager[type](item.message, { duration });
    }
  } else {
    NotificationManager[type](message, { duration });
  }
};
